import { useContext } from "react";
import axios from 'axios';
import { Context } from "../Reducers/Store";

let isRenewing = false;
let pendingRequests = [];

function onTokenRenewed(newToken) {
    pendingRequests.forEach(callback => callback(newToken));
    pendingRequests = [];
}

function addPendingRequest(callback) {
    pendingRequests.push(callback);
}

// Hook
export function useTokenHelper() {
    const [state, dispatch] = useContext(Context);

    const getToken = async () => {
        const token = state.jwt;
        if (!token) return null;

        const refreshToken = state.refreshToken;
        if (!refreshToken) return token;

        const currentTime = Date.now() / 1000;

        if (state.jwtDecoded.exp < currentTime) {
            if (!isRenewing) {
                isRenewing = true;
                try {
                    const res = await axios.post(process.env.REACT_APP_API + "/auth/refresh", { refresh_token: refreshToken, email: state.profile?.email, rememberMe: true });
                    const newToken = res.data.access_token;
                    dispatch({ type: "SET_LOGGED", payload: res.data });
                    isRenewing = false;
                    onTokenRenewed(newToken);
                    return newToken;
                } catch (error) {
                    isRenewing = false;
                    onTokenRenewed(token);
                }
            } else {
                return new Promise(resolve => {
                    addPendingRequest(resolve);
                });
            }
        }

        return token;
    };

    return {
        getToken
    };
}